module.exports = __webpack_public_path__ + "img/concrete-hole-decal-12.0193a978.png";